<div class="package mb-5">
  <div
    class="overlay"
    lumAppLoader
    [loading]="loading"
    [classes]="'loading blur'"
  ></div>

  <div class="p-5">
    <div class="d-flex justify-content-between">
      <!-- Left Aligned Title -->
      <div class="align-self-center">
        <!-- TODO MAKE DYNAMIC FOR OTHER MODULES -->
        <h3 class="mt-4">Invoice Template</h3>
      </div>

      <!-- Right Aligned Close Button -->
      <div class="align-self-center">
        <button
          type="button"
          class="lum-button lum-button--secondary"
          mat-button
          (click)="dialogRef.close()"
        >
          <lum-ui-icon
            class="mr-2-5"
            icon="close-circle"
            color="#5563D6"
            width="23"
            height="23"
          ></lum-ui-icon>
          Close
        </button>
      </div>
    </div>
    <mat-divider class="my-2"></mat-divider>
  </div>
  <div class="p-5">
    <lum-package-filters
      class="mb-2"
      (searchEvent)="onSearchEvent($event)"
    ></lum-package-filters>

    <ng-container *ngIf="loading === false">
      <lum-package-table
        *ngIf="data?.length; else empty"
        (deleteEvent)="onDeleteEvent($event)"
        [data]="data"
      ></lum-package-table>
      <ng-container *ngIf="data && data.length > 0">
        <mat-paginator
          [length]="pagination.total || 0"
          [pageSize]="pagination.per_page || paginationConfig.perPage"
          [pageSizeOptions]="paginationConfig.pageSizeOptions"
          [pageIndex]="(pagination.current_page || 1) - 1"
          (page)="onPaginationEvent($event)"
          aria-label="Select page"
        >
        </mat-paginator>
      </ng-container>
    </ng-container>

    <ng-template #empty>
      <lum-ui-empty-page title="No records available."></lum-ui-empty-page>
    </ng-template>
  </div>
</div>
